import React from "react";
import { Alert, Box, Checkbox, FormControlLabel, Link, Typography } from "@mui/material";

export const SMS_CONSENT_TEXT =
  "I agree to receive SMS messages from Timely365, operated by Micro Logic LLC, regarding appointment reminders, booking confirmations, scheduling updates, service notifications, and customer support follow-up. Message frequency varies. Message and data rates may apply. Reply STOP to opt out and HELP for help. Consent is not a condition of purchase.";

export default function SmsConsentCheckbox({
  checked,
  onChange,
  error,
  sx = {},
  checkboxProps = {},
}) {
  return (
    <Box
      sx={{
        mt: 1,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: error ? "error.main" : "divider",
        bgcolor: "background.paper",
        ...sx,
      }}
    >
      <FormControlLabel
        sx={{ alignItems: "flex-start", m: 0 }}
        control={
          <Checkbox
            required
            checked={!!checked}
            onChange={(event) => onChange?.(event.target.checked)}
            inputProps={{ "aria-label": "SMS consent", ...checkboxProps.inputProps }}
            {...checkboxProps}
          />
        }
        label={
          <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
            {SMS_CONSENT_TEXT}
          </Typography>
        }
      />
      <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 2, rowGap: 0.5,
        ml: '42px', mt: 1, fontSize: '0.8125rem', lineHeight: 1.5,
        '& a': { fontSize: 'inherit', fontWeight: 400, py: 0.5,
          textUnderlineOffset: '3px', textDecorationThickness: '1px' } }}>
        <Link href="/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        <Link href="/terms" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </Link>
      </Box>
      {error ? (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      ) : null}
    </Box>
  );
}
